import type {PermissionsRecordType} from '../permissions';

export const oauthClientPermissions = {
  readOAuthClient: {
    actionId: 'READ',
    resourceId: 'OAUTH_CLIENT',
    scopes: [],
  },
  createOAuthClient: {
    actionId: 'CREATE',
    resourceId: 'OAUTH_CLIENT',
    scopes: [],
  },
  updateOAuthClient: {
    actionId: 'UPDATE',
    resourceId: 'OAUTH_CLIENT',
    scopes: [],
  },
  deleteOAuthClient: {
    actionId: 'DELETE',
    resourceId: 'OAUTH_CLIENT',
    scopes: [],
  },
  regenerateOAuthClientSecret: {
    actionId: 'REGENERATE_SECRET',
    resourceId: 'OAUTH_CLIENT',
    scopes: [],
  },
} satisfies PermissionsRecordType;
